module.exports = require("./ky-KG.js");